/* VHI_THEME_VARIANT_TAG | added 2026-08-30 for the Sept live-vs-Layer split test.
   Sends a GA4 user property so the funnel can be segmented by theme.
   REVERT: delete this file and remove the script_tag line from snippets/css-variables.liquid. */
(function () {
  try {
    window.dataLayer = window.dataLayer || [];
    var g = function () { window.dataLayer.push(arguments); };
    g('set', 'user_properties', { theme_variant: 'live' });
    window.__vhiThemeVariant = 'live';
  } catch (e) {}
})();
